import { Image } from '../common';

export type WikiTabType = 'content' | 'approval_process' | 'quiz';

export type WikiEditTab = {
   url: string;
   active: boolean;
   name: string;
};

export type WikiEditNavLinks = {
   shouldViewDraft: boolean;
   backText?: string;
   backLink?: string;
   viewLink: string;
   historyLink: string;
   editLink: string;
   editText: string;
   translateText: string;
   translateLink: string;
};

export type WikiEditTabsAndNavResponse = {
   tabs: WikiEditTab[];
   navLinks: WikiEditNavLinks;
};

export type Author = {
   userid: number;
   username: string;
   join_date: number;
   enabled: boolean;
   banned: boolean | null;
   image: Image;
};

export type UnsavedWikiObject = {
   dataType: 'wiki';
   display_title: string;
   image: Image;
   modified_date: number;
   summary: string;
   text: string;
   title: string;
   url: string;
   fullUrl?: string;
};

export type WikiObject = UnsavedWikiObject & {
   wikiid: number;
   revisionid: number;
   major_approval_processid: number | null;
   minor_approval_processid: number | null;
   default_child_major_approval_processid: number | null;
   default_child_minor_approval_processid: number | null;
   can_set_approval_processes: boolean;
};

export type UnsavedWikiPage = UnsavedWikiObject & {
   namespace: 'WIKI';
};

export type WikiPage = WikiObject & UnsavedWikiPage;

export type UnsavedCategory = UnsavedWikiObject & {
   namespace: 'CATEGORY';
};

export type Category = WikiObject & UnsavedCategory;

export type UnsavedDevice = UnsavedWikiObject & {
   namespace: 'DEVICE';
};

export type Device = WikiObject & UnsavedCategory;

export enum WikiNamespaces {
   WIKI = 'WIKI',
   CATEGORY = 'CATEGORY',
   ITEM = 'ITEM',
   TEAM = 'TEAM',
   COURSE = 'COURSE',
   USER = 'USER',
}
